export const parseSteamIdFromURL = (url: string): string => {
    const steamId = (url.split('/profiles/')[1] ?? url.split('/id')[1])?.replace('/', '');

    return steamId;
};


export const checkIsValidURL = (url: string) => {
    const regex = /https:\/\/steamcommunity\.com\/(profiles|id)\/[A-Za-z0-9]+/i;
    const isValidURL = regex.test(url ?? '');

    return isValidURL;
}